export default __webpack_public_path__ + "static/media/Profile.1c99cc3d.svg";